import { useParams, Link } from 'react-router-dom';
import { mockArticles } from '@/mocks/articles';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = mockArticles.find((a) => a.id === id);

  if (!article) {
    return (
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-article-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl font-semibold text-foreground-900 mb-2">文章未找到</h1>
          <p className="text-sm text-foreground-500 mb-6">该文章可能已被删除或链接错误</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-16 min-h-screen bg-background-50">
      <article className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <div className="flex items-center flex-wrap gap-3 mb-4">
              <span className="px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                {article.category}
              </span>
              {article.tags.map((tag) => (
                <span key={tag} className="text-xs text-foreground-500">#{tag}</span>
              ))}
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-sm text-foreground-500">
              <span><i className="ri-user-line mr-1"></i>{article.author}</span>
              <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
              <span><i className="ri-eye-line mr-1"></i>{article.views}阅读</span>
            </div>
          </div>

          <div className="mb-8 rounded-xl overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              title={`${article.title} - 蘑菇视频官网`}
              className="w-full aspect-video object-cover"
            />
          </div>

          <div
            className="prose-custom text-foreground-800 leading-relaxed text-sm md:text-base"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex flex-wrap gap-2">
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    #{tag}
                  </span>
                ))}
              </div>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
                返回首页
              </Link>
            </div>
          </div>
        </div>
      </article>

      <style>{`
        .prose-custom p {
          margin-bottom: 1.25rem;
          line-height: 1.85;
        }
        .prose-custom h3 {
          margin-top: 2rem;
          margin-bottom: 0.75rem;
          font-size: 1.125rem;
          font-weight: 600;
          color: oklch(var(--foreground-900));
        }
      `}</style>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: article.title,
          description: article.summary,
          image: article.image,
          datePublished: article.date,
          author: {
            '@type': 'Person',
            name: article.author,
          },
          publisher: {
            '@type': 'Organization',
            name: '蘑菇视频',
          },
        })}
      </script>
    </main>
  );
}